import * as React from "react"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { Check } from "@mui/icons-material"

export const theme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          borderRadius: "20px !important",
          color: "#303139 !important",
          fontSize: "20px !important",
          left: "0px !important",
          paddingInline: "8px !important",
          top: "-10px !important",
          transition: "all 200ms cubic-bezier(0.0, 0, 0.2, 1) !important",
        },
        shrink: {
          backgroundColor: "white !important",
          top: "-7px !important",
          "&.Mui-focused:not(.Mui-error)": { color: "#656772 !important" },
          "&.Mui-error": { color: "#d32f2f !important" },
          width: "fit-content !important",
          fontSize: "22px !important",
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: <Check />,
      },
      styleOverrides: {
        root: {
          color: "#336cff",
          marginLeft: 3,
          padding: 6,

          svg: {
            fontSize: 20,
          },

          "&.Mui-checked": {
            svg: {
              backgroundColor: "#336cff",
              borderRadius: 3,
              color: "white",
              transform: "scale(0.75)",
            },
          },

          "& + .MuiTypography-root": {
            color: "black !important",
            fontSize: "20px !important",
            userSelect: "none",
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "black !important",
          fontSize: "18px !important",
          marginTop: "0px !important",
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          marginTop: 3,
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "100%",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: { width: "fit-content" },
        label: { fontSize: "20px !important" },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          marginLeft: 22,
          marginTop: 0,
          lineHeight: 1.3,
          paddingBottom: 5,

          "&.Mui-error": { color: "#C74A4A" },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "white !important",
          borderRadius: "20px !important",
          height: "fit-content !important",
          fieldset: { display: "none !important" },
          boxShadow: "0px 5px 7px -4px lightgrey !important",
          width: "100% !important",
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionEnd: {
          paddingRight: "8px !important",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "white !important",
          borderRadius: "inherit !important",
          "&.Mui-error": { color: "#C74A4A !important", boxShadow: "inset 0px 0px 0px 1px #C74A4A !important" },
          padding: "0 !important",
        },
        input: {
          boxShadow: "none !important",
          fontSize: "20px !important",
          padding: "10px 20px !important",
          '&[class*="Multiline"]': {
            paddingBottom: "0 !important",
          },
          "&:not(:first-of-type)": {
            paddingLeft: "10px !important",
          },
          "&:active, &:disabled": {
            backgroundColor: "transparent !important",
            color: "black !important",
          },
          "&:focus": {
            outline: "none !important",
            color: "black !important",
          },
          "&:hover": {
            color: "black !important",
          },
        },
        adornedEnd: {
          paddingRight: "15px !important",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          /* Hide scrollbar for Chrome, Safari and Opera */
          "&::-webkit-scrollbar": {
            display: "none !important",
          },

          msOverflowStyle: "none !important" as any,
          /* IE and Edge */
          scrollbarWidth: "none !important" as any,
          /* Firefox */
        },
        multiline: {
          textarea: {
            minHeight: "100px !important",
          },
        },
        input: {
          boxSizing: "border-box",
          border: "none !important",
          borderRadius: "inherit",
          '&:not([class*="Multiline"])': {
            height: "40px !important",
          },
          color: "black !important",

          "&::placeholder": {
            color: "black !important",
            opacity: "1 !important",
          },
          "&:hover, &:active, &:focus": {
            color: "black !important",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: "unset !important",
          fontSize: "14px !important",
          whiteSpace: "normal",
          lineHeight: "normal",
        },
        deleteIcon: {
          marginRight: "0 !important",
          padding: "2px !important",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          width: "100%",
        },
        inputRoot: {
          padding: "0 30px 0 15px !important",
        },
        option: {
          fontSize: "18px",
          paddingLeft: "22px !important",
          position: "relative !important" as any,

          "&:not(:first-of-type):before": {
            content: '""',
            position: "absolute",
            left: 20,
            top: 0,
            height: 0,
            width: "calc(100% - 40px)",
            borderTop: "1px solid #e6e6e6",
          },
        },
        loading: { fontSize: "16px !important", paddingLeft: "22px !important" },
        noOptions: { fontSize: "16px !important", paddingLeft: "22px !important" },
        popper: {
          zIndex: "100000000 !important",
        },
        paper: {
          borderRadius: "20px !important",
          marginTop: "10px !important",
          boxShadow: "0px 5px 7px -4px lightgrey !important",
        },
        input: {
          padding: "7.5px 18px 7.5px 6px !important",
        },
        endAdornment: {
          top: "calc(50% - 16px) !important",
          svg: {
            fontSize: "22px !important",
          },
        },
        popupIndicator: {
          marginRight: "-8px !important",
          padding: "0 !important",
          svg: {
            fontSize: "30px !important",
          },
        },
        clearIndicator: {
          svg: {
            fontSize: "20px !important",
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
      },
      styleOverrides: {
        root: {
          borderRadius: "32px !important",
          textTransform: "none !important" as any,
          fontSize: "16px !important",
        },
        contained: {
          borderRadius: "32px !important",
          color: "white !important",
          fontWeight: "bold !important",
          fontSize: "16px !important",
          padding: "2px 22px !important",
          width: "fit-content !important",
        },
        text: {
          padding: 0,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "20px !important",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          paddingBlock: 5,

          "& + .MuiTypography-root": {
            fontSize: "20px !important",
          },

          svg: {
            fontSize: "20px !important",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          overflow: "initial !important",

          "& + .MuiTypography-root": {
            fontSize: "24px !important",
          },
        },
        input: {
          "&:disabled": {
            opacity: "0 !important",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        popper: {
          zIndex: "100000 !important",
        },
        tooltip: {
          fontSize: "16px !important",
        },
      },
    },
  },
  palette: {
    primary: { main: "#336cff" }, // $aqua-blue
    secondary: { main: "#62d588" }, // $rare-green
  },
  typography: {
    fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
  },
})

const MuiThemeProvider = ({ children }: React.PropsWithChildren) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default MuiThemeProvider
